// firebase
import { collection, doc, getDocs, addDoc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "config/firebase";

// utils
import unixTimestampInSeconds from "utils/unixTimestampInSeconds";

// A ---------------------------------------------------------------------- M

export const fetchAlarmContacts = async (tagID) => {
  try {
    const contactsRef = collection(db, "tagsdata", tagID, "alarm_contacts");
    const snap = await getDocs(contactsRef);

    return snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("[fetchAlarmContacts] Error:", error);
    return [];
  }
};

export const addAlarmContact = async (tagID, contact) => {
  try {
    const contactsRef = collection(db, "tagsdata", tagID, "alarm_contacts");

    const contactData = {
      first_name: contact.first_name.trim(),
      last_name: contact.last_name.trim(),
      phone: contact.phone.trim(),
      enabled: contact.enabled ?? true,
      created_at: unixTimestampInSeconds(),
    };

    await addDoc(contactsRef, contactData);
    console.log(`[addAlarmContact] Contact added to ${tagID}`);
    return true;
  } catch (error) {
    console.error("[addAlarmContact] Error:", error);
    throw new Error("Failed to add alarm contact");
  }
};

export const updateAlarmContact = async (tagID, contactID, updates) => {
  try {
    const contactRef = doc(db, "tagsdata", tagID, "alarm_contacts", contactID);
    await updateDoc(contactRef, updates);
    console.log(`[updateAlarmContact] Contact ${contactID} updated in ${tagID}`);
    return true;
  } catch (error) {
    console.error("[updateAlarmContact] Error:", error);
    throw new Error("Failed to update alarm contact");
  }
};

export const deleteAlarmContact = async (tagID, contactID) => {
  try {
    const contactRef = doc(db, "tagsdata", tagID, "alarm_contacts", contactID);
    await deleteDoc(contactRef);
    console.log(`[deleteAlarmContact] Contact ${contactID} deleted from ${tagID}`);
    return true;
  } catch (error) {
    console.error("[deleteAlarmContact] Error:", error);
    throw new Error("Failed to delete alarm contact");
  }
};
